import script from "./EngineeringProjectsView.vue?vue&type=script&setup=true&lang=js"
export * from "./EngineeringProjectsView.vue?vue&type=script&setup=true&lang=js"

import "./EngineeringProjectsView.vue?vue&type=style&index=0&id=4947bf87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4947bf87"]])

export default __exports__